import { HeadCell, TXN_PAYOUT_TYPE } from 'models';

export const headCells: readonly HeadCell<TXN_PAYOUT_TYPE>[] = [
  {
    id: 'number',
    numeric: false,
    disablePadding: true,
    isSort: true,
    label: 'TXN No.',
  },
  {
    id: 'type',
    numeric: false,
    disablePadding: true,
    isSort: true,
    label: 'TXN Type',
  },
  {
    id: 'doc_ref_no',
    numeric: false,
    disablePadding: true,
    isSort: true,
    label: 'Doc Ref No.',
  },
  {
    id: 'total_amount',
    numeric: true,
    disablePadding: true,
    isSort: true,
    label: 'Total Amount',
  },
];
